import styles from './styles.less';
import React from 'react';

import Content from '../content';
 import cx from 'classnames';


class Split extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        const data = this.props.data;
        const { left, right } = data;

        const leftClassName = cx(styles.column, styles[left.size]);
        const rightClassName = cx(styles.column, styles[right.size]);

        return (
            <div className={ this.props.className }>
                <div className={ leftClassName }>
                    { left.content.map((content, i) => (
                        <Content
                            key={ i }
                            data={ content }
                        />
                    )) }
                </div>

                <div className={ rightClassName }>
                    { right.content.map((content, i) => (
                        <Content
                            key={ i }
                            data={ content }
                        />
                    )) }
                </div>
            </div>
        );
    }
}


export default Split;



// WEBPACK FOOTER //
// ./src/client/components/split/index.js